module.exports = __webpack_public_path__ + "static/media/Apple Watch 40mm Space Black Titanium + Pine Green Closed.7dbf41ff.png";